import api from "./api";
import commonApi from "../common/api";
import log from "loglevel";
import _ from "lodash";
import ua from "../../../lib/useragent.js";
import {
  dataUrlToBlob,
  loadImageWithOrientationCorrection
} from "../../../lib/image";

const state = {
  draftId: null,
  jwt: "",
  isSecureView: false,
  isUploadingImage: false,
  uploadedImage: [],
  uploadingImage: [],
  isUpdatedImage: false,
  enablePostStep1: false,
  enablePostStep2: false,
  enablePostStep3: false,
  isUploadIceContents: false,
  iceContentsPageCount: 0,
  iceContentsHasCover: false,
  stepNumber: 1,

  // STEP1
  pageProgressionDirection: "rtl",
  images: [],
  frontCoverType: "simple",
  backCoverType: "simple",
  userFrontCoverImageUrl: "",
  userBackCoverImageUrl: "",
  frontCoverImageWidth: 0,
  frontCoverImageHeight: 0,
  isSetFrontCoverNext: false,
  isSetBackCoverPrev: false,
  uploadingImageCount: 0,
  // ComicEditorで表紙裏表紙を表示するための固定データ
  frontCoverData: {
    name: "frontCoverImage",
    fileName: "",
    imageId: -99991,
    isBlank: false,
    notMove: true,
    isBody: false
  },
  frontCoverNextData: {
    imageId: -99992,
    staticImageName: "frontCoverNextImage",
    isBlank: false,
    notMove: true,
    isBody: true
  },
  backCoverPrevData: {
    imageId: -99998,
    staticImageName: "backCoverPrevImage",
    isBlank: false,
    notMove: true,
    isBody: true
  },
  backCoverData: {
    name: "backCoverImage",
    fileName: "",
    imageId: -99999,
    isBlank: false,
    notMove: true,
    isBody: false
  },
  staticBlankData: {
    imageId: -99995,
    staticImageName: "blankArea",
    isBlank: false,
    isBody: true,
    notMove: true
  },

  // STEP2
  title: "",
  description: "",
  defaultThumbnailOriginalImageUrl: "",
  defaultThumbnailCroppedImageUrl: "",
  userThumbnailOriginalImageUrl: "",
  userThumbnailCroppedImageUrl: "",
  defaultOriginalSocialMediaImageUrl: "",
  defaultCroppedSocialMediaImageUrl: "",
  userOriginalSocialMediaImageUrl: "",
  userCroppedSocialMediaImageUrl: "",
  sizeSelect: "big",
  size: "A4",
  aspectRatioType: "book_size_ratio",
  orientation: "portrait",
  coverHardness: "soft",
  coverProcess: "coated_nonprocessed",
  bodyPaperType: "book_paper",
  spineCoverType: "simple",
  isSetSpine: false,
  defaultSpineImageFile: null,
  defaultSpineImageUrl: "",
  userSpineImageFile: null,
  userSpineImageUrl: "",
  isDefaultHybrid3d: true,
  previewUrl: null,
  isUpdatedHybrid3dSettings: false,

  // STEP3
  publicationType: "",
  secretWord: "",
  isSensitive: false,
  isCommentEnabled: true,
  isClientEnabledCircleMs: false,
  isEnabledCircleMs: false
};

// getters
const getters = {
  /**
   * バリテーション系   *
   */
  enablePostStep1: state => {
    return (
      // 画像が存在し、アップロード完了した画像が存在すること
      state.images.filter(
        image => image.imageId > 0 && !image.notMove && image.src
      ).length > 0 &&
      // アップロード中の画像が存在しないこと
      state.images.filter(image => !image.notMove && image.imageId < 0)
        .length === 0
    );
  },
  enablePostStep2: state => {
    return (
      (state.defaultThumbnailCroppedImageUrl !== "" ||
        state.userThumbnailCroppedImageUrl !== "") &&
      (state.defaultCroppedSocialMediaImageUrl !== "" ||
        state.userCroppedSocialMediaImageUrl !== "") &&
      state.title.length > 0 &&
      state.title.length <= 50 &&
      state.title.trim() !== "" &&
      state.description.length > 0 &&
      state.description.length <= 200 &&
      state.description.trim() !== ""
    );
  },
  enablePostStep3: state => {
    if (state.isSecureView) {
      return true;
    }
    if (state.publicationType === "public") {
      return true;
    } else if (state.publicationType === "secret_word") {
      return (
        state.secretWord.length > 0 &&
        state.secretWord.length <= 50 &&
        state.secretWord.trim() !== ""
      );
    }
    return false;
  },

  /**
   * APIパラメータ
   *
   */

  postDraftParams: state => ({
    jwt: state.jwt
  }),
  putDraftParams: state => ({
    draftId: state.draftId,
    title: state.title,
    description: state.description,
    pageProgressionDirection: state.pageProgressionDirection,
    publicationType: state.publicationType,
    secretWord: state.secretWord,
    isSensitive: state.isSensitive,
    isCommentEnabled: state.isCommentEnabled,
    isEnabledCircleMs: state.isEnabledCircleMs,
    isDefaultHybrid3d:
      state.pageProgressionDirection === "vertical"
        ? false
        : state.isDefaultHybrid3d,
    frontCoverType:
      state.pageProgressionDirection === "vertical"
        ? null
        : state.frontCoverType,
    backCoverType:
      state.pageProgressionDirection === "vertical"
        ? null
        : state.backCoverType,
    spineCoverType:
      state.pageProgressionDirection === "vertical"
        ? null
        : state.spineCoverType,
    size: state.pageProgressionDirection === "vertical" ? null : state.size,
    aspectRatioType:
      state.pageProgressionDirection === "vertical"
        ? null
        : state.pageProgressionDirection === "single"
        ? "image_ratio"
        : state.aspectRatioType,
    orientation:
      state.pageProgressionDirection === "vertical" ? null : state.orientation,
    coverHardness:
      state.pageProgressionDirection === "vertical"
        ? null
        : state.coverHardness,
    coverProcess:
      state.pageProgressionDirection === "vertical" ? null : state.coverProcess,
    bodyPaperType:
      state.pageProgressionDirection === "vertical" ? null : state.bodyPaperType
  }),
  postDraftImageParams: state => isBlank => ({
    draftId: state.draftId,
    isBlank: isBlank
  }),
  postDraftThumbnailImageParams: state => isDefault => ({
    draftId: state.draftId,
    isDefault: isDefault
  }),
  postDraftThumbnailImageCompleteParams: state => isDefault => ({
    draftId: state.draftId,
    isDefault: isDefault
  }),
  deleteDraftThumbnailImageParams: state => ({
    draftId: state.draftId
  }),
  postDraftSocialMediaImageParams: state => isDefault => ({
    draftId: state.draftId,
    isDefault: isDefault
  }),
  postDraftSocialMediaImageCompleteParams: state => isDefault => ({
    draftId: state.draftId,
    isDefault: isDefault
  }),
  deleteDraftSocialMediaImageParams: state => ({
    draftId: state.draftId
  }),
  postDraftCoverImageParams: state => ({
    draftId: state.draftId
  }),
  postDraftCoverImageCompleteParams: state => ({
    draftId: state.draftId
  }),
  deleteDraftCoverImageParams: state => ({
    draftId: state.draftId
  }),
  postDraftSpineImageParams: state => params => ({
    draftId: state.draftId,
    isDefault: params.isDefault
  }),
  postDraftSpineImageCompleteParams: state => params => ({
    draftId: state.draftId,
    isDefault: params.isDefault
  }),
  deleteDraftSpineImageParams: state => params => ({
    draftId: state.draftId,
    isDefault: params.isDefault
  }),
  postPublishParams: state => ({
    draftId: state.draftId,
    jwt: state.jwt
  }),
  getPublishProgressParams: state => ({
    draftId: state.draftId,
    jwt: state.jwt
  }),
  postDraftPreviewParams: (state, getters) => ({
    draftId: state.draftId,
    pageCount: getters.pageCountContainsCover
  }),
  getDraftPreviewProgressParams: (state, getters) => ({
    draftId: state.draftId,
    pageCount: getters.pageCountContainsCover
  }),
  getIceContentsInitialSettingsParams: state => ({
    draftId: state.draftId
  }),

  thumbnailOriginalImageUrl: state => {
    if (state.userThumbnailOriginalImageUrl) {
      return state.userThumbnailOriginalImageUrl;
    } else if (state.defaultThumbnailOriginalImageUrl) {
      return state.defaultThumbnailOriginalImageUrl;
    } else {
      return "";
    }
  },
  thumbnailCroppedImageUrl: state => {
    if (state.userThumbnailCroppedImageUrl) {
      return state.userThumbnailCroppedImageUrl;
    } else if (state.defaultThumbnailCroppedImageUrl) {
      return state.defaultThumbnailCroppedImageUrl;
    } else {
      return "";
    }
  },
  originalSocialMediaImageUrl: state => {
    if (state.userOriginalSocialMediaImageUrl) {
      return state.userOriginalSocialMediaImageUrl;
    } else if (state.defaultOriginalSocialMediaImageUrl) {
      return state.defaultOriginalSocialMediaImageUrl;
    } else {
      return "";
    }
  },
  croppedSocialMediaImageUrl: state => {
    if (state.userCroppedSocialMediaImageUrl) {
      return state.userCroppedSocialMediaImageUrl;
    } else if (state.defaultCroppedSocialMediaImageUrl) {
      return state.defaultCroppedSocialMediaImageUrl;
    } else {
      return "";
    }
  },
  coverThicknessPerSheet: state => {
    switch (state.coverHardness) {
      case "soft":
      default:
        return 0.3;
      case "hard":
        return 2.5;
    }
  },
  contentThicknessPerSheet: state => {
    switch (state.bodyPaperType) {
      case "book_paper":
      default:
        return 0.13;
      case "coated":
        return 0.15;
    }
  },
  pageCountContainsCover: state => {
    if (state.isUploadIceContents) {
      return state.iceContentsPageCount;
    } else {
      return state.images.length;
    }
  },
  contentSheetNum: state => {
    if (state.isUploadIceContents) {
      const pageCount = Math.max(
        state.iceContentsPageCount - (state.iceContentsHasCover ? 4 : 0),
        0
      );
      return Math.ceil(pageCount / 2);
    } else {
      return Math.ceil(state.images.filter(image => !image.notMove).length / 2);
    }
  },
  spineImageWidthMM: (state, getters) => {
    const coverSheetNum = 2;
    const contentSheetNum = getters.contentSheetNum;

    return (
      getters.contentThicknessPerSheet * contentSheetNum +
      getters.coverThicknessPerSheet * coverSheetNum
    );
  },
  spineImageHeightMM: state => {
    switch (state.size) {
      case "A4":
        return 297;
      case "B5":
        return 257;
      case "B6":
        return 182;
    }
  },
  spineImageWidthRecommended: (state, getters) => {
    return Math.ceil(
      getters.spineImageHeightRecommended *
        (getters.spineImageWidthMM / getters.spineImageHeightMM)
    );
  },
  spineImageHeightRecommended: state => {
    if (state.frontCoverImageHeight > 0) {
      return state.frontCoverImageHeight;
    } else {
      return 960;
    }
  },
  spineImageUrl: state => {
    switch (state.spineCoverType) {
      case "simple":
      default:
        return state.defaultSpineImageUrl;
      case "user_upload":
        return state.userSpineImageUrl;
    }
  },
  getImageProgress: state => {
    const uploadingImage = state.uploadingImageCount;
    const uploadedImage = state.uploadedImage.length;

    log.debug(
      "uploadingImage:",
      uploadingImage,
      "/ uploadedImage:",
      uploadedImage
    );

    if (uploadingImage > 0) {
      log.debug("progress:", (100 / uploadingImage) * uploadedImage);
      return Math.floor((100 / uploadingImage) * uploadedImage);
    } else {
      return 0;
    }
  },
  getProgressText: state => {
    return `${state.uploadedImage.length} / ${state.uploadingImageCount}`;
  },
  getPageProgressionDirection: state => {
    return state.pageProgressionDirection;
  },
  updateHybrid3dSettingsParams: (state, getters) => ({
    draftId: state.draftId,
    size: state.size,
    aspectRatioType: state.aspectRatioType,
    coverHardness: state.coverHardness,
    coverProcess: state.coverProcess,
    bodyPaperType: state.bodyPaperType,
    spineCoverType: state.spineCoverType,
    isDefaultHybrid3d: state.isDefaultHybrid3d,
    pageCount: getters.pageCountContainsCover
  }),
  getNotIncludeCoverDataImageCount: state => {
    return state.images.filter(image => !image.notMove).length;
  }
};

// actions
const actions = {
  async postDraftImage(context, params) {
    async function processError(error) {
      context.commit("removeImages", preImageId);
      context.commit("refreshImages");
      log.error("postDraftImage error:", error);
      context.commit("common/setError", error, { root: true });
      if (imageId) {
        try {
          await api.deleteDraftImage({ imageId });
        } catch (e) {
          // NOP
        }
      }
      throw error;
    }

    const { draftId } = context.state;
    const { preImageId } = params;
    const apiParams = { draftId, isBlank: false, filename: params.name };

    const postDraftImageRes = await api.postDraftImage(apiParams);
    const imageId = postDraftImageRes.data.imageId;

    await commonApi
      .postS3Image(postDraftImageRes.data.signedUrl, params.file)
      .catch(error => processError(error));
    const resComplete = await api
      .postDraftImageComplete({
        draftId,
        imageId: imageId
      })
      .catch(error => processError(error));
    log.debug("postDraftImageComplete:", resComplete);

    const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
    if (ua.getBrowser().name === "IE") {
      await sleep(15000);
    }

    const image = {
      src: resComplete.data.imageUrl,
      name: params.name,
      imageId: imageId,
      isBlank: false,
      isBody: true
    };
    context.commit("pushUploadedImage", image);
    context.commit("updateImages", {
      imageId: preImageId,
      image: image
    });

    return true;
  },
  async postDraftStaticImage(context, params) {
    const { draftId } = context.state;
    const { preImageId } = params;
    const { isFrontNext } = params;
    const apiParams = { draftId, isBlank: false, filename: params.name };
    let imageId = null;

    try {
      const postDraftImageRes = await api.postDraftImage(apiParams);
      imageId = postDraftImageRes.data.imageId;

      await commonApi.postS3Image(
        postDraftImageRes.data.signedUrl,
        params.file
      );
      const resComplete = await api.postDraftImageComplete({
        draftId,
        imageId: imageId
      });

      log.debug("postDraftImageComplete:", resComplete);

      const imageName = isFrontNext
        ? "frontCoverNextImage"
        : "backCoverPrevImage";
      const mutationsName = isFrontNext
        ? "updateFrontCoverNextData"
        : "updateBackCoverPrevData";

      if (preImageId > 0) {
        await api.deleteDraftImage({
          imageId: preImageId
        });
      }

      context.commit(mutationsName, {
        staticImageName: imageName,
        src: resComplete.data.imageUrl,
        name: params.name,
        imageId: imageId,
        isBlank: false,
        isBody: true,
        notMove: true
      });

      const image = {
        staticImageName: imageName,
        src: resComplete.data.imageUrl,
        name: params.name,
        imageId: imageId,
        isBlank: false,
        isBody: true,
        notMove: true
      };

      context.commit("pushUploadedImage", image);

      context.commit("updateImages", {
        imageId: preImageId,
        image: image
      });

      return true;
    } catch (error) {
      context.commit("removeImages", preImageId);
      log.error("postDraftImage error:", error);
      context.commit("common/setError", error, { root: true });
      if (imageId) {
        try {
          await api.deleteDraftImage({ imageId });
        } catch (e) {
          // NOP
        }
      }
    }
  },
  async postDraftBlankImage(context) {
    const { isBlank = true, draftId } = context.state;
    const { commit } = context;

    const preImageId = parseInt(_.uniqueId()) * -1;
    const preImage = { imageId: preImageId, isBlank };

    commit("pushImages", preImage);

    try {
      const res = await api.postDraftImage({ isBlank, draftId });

      const image = {
        name: "blankImage",
        imageId: res.data.imageId,
        isBlank: true,
        isBody: true
      };

      context.commit("pushUploadedImage", image);

      commit("updateImages", {
        imageId: preImageId,
        image: image
      });

      return true;
    } catch (error) {
      log.error("postDraftBlankImage error:", error);
      context.commit("refreshImages");
      context.commit("common/setError", error, { root: true });
      throw error;
    }
  },
  async deleteDraftImage(context, imageId) {
    log.debug("deleteDraftImage:", imageId);
    context.commit("startDeleteDraftImage", imageId);
    try {
      const res = await api.deleteDraftImage({ imageId });
      context.commit("removeImages", imageId);
      context.commit("refreshImages");

      return res;
    } catch (error) {
      log.error("deleteDraftImage error:", error);
      throw error;
    }
  },
  async postDraft(context) {
    try {
      const res = await api.postDraft(context.getters.postDraftParams);
      context.commit("successPostDraft", res.data);

      return res;
    } catch (error) {
      log.error("postDraft error:", error);
      context.commit("common/setError", error, { root: true });
      throw error;
    }
  },
  async putDraft(context) {
    try {
      return await api.putDraft(context.getters.putDraftParams);
    } catch (error) {
      log.error("putDraft error:", error);
      context.commit("common/setError", error, { root: true });
      throw error;
    }
  },
  async sortImages(context, { draftId, afterImages, beforeImages }) {
    context.commit("updateSortImages", afterImages);
    afterImages = afterImages.filter(image => image.isBody);

    try {
      const res = await api.putDraftImageOrder({
        draftId,
        images: afterImages
      });
      log.debug("res:", res);

      return res;
    } catch (error) {
      log.error("sortImages error:", error);
      context.commit("common/setError", error, { root: true });
      //ロールバック
      context.commit("updateSortImages", beforeImages);
    }
  },
  async postThumbnailImage(context, blob) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      const postRes = await api.postDraftThumbnailImage(
        context.getters.postDraftThumbnailImageParams(false)
      );
      await commonApi.postS3Image(postRes.data.signedUrl, blob);
      const completeRes = await api.postDraftThumbnailImageComplete(
        context.getters.postDraftThumbnailImageCompleteParams(false)
      );
      context.commit(
        "updateUserThumbnailCroppedImageUrl",
        completeRes.data.imageUrl
      );

      return completeRes;
    } catch (error) {
      log.error("postThumbnailImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async deleteThumbnailImage(context) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      await api.deleteDraftThumbnailImage(
        context.getters.deleteDraftThumbnailImageParams
      );
      context.commit("updateUserThumbnailCroppedImageUrl", "");
    } catch (error) {
      log.error("deleteThumbnailImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async postDefaultThumbnailImage(context, blob) {
    try {
      const postRes = await api.postDraftThumbnailImage(
        context.getters.postDraftThumbnailImageParams(true)
      );
      await commonApi.postS3Image(postRes.data.signedUrl, blob);
      const completeRes = await api.postDraftThumbnailImageComplete(
        context.getters.postDraftThumbnailImageCompleteParams(true)
      );
      context.commit(
        "updateDefaultThumbnailCroppedImageUrl",
        completeRes.data.imageUrl
      );

      return completeRes.data.imageUrl;
    } catch (error) {
      log.error("postDefaultThumbnailImage error:", error);
      context.commit("common/setError", error, { root: true });
    }
  },
  async postSocialMediaImage(context, blob) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      const postRes = await api.postDraftSocialMediaImage(
        context.getters.postDraftSocialMediaImageParams(false)
      );
      await commonApi.postS3Image(postRes.data.signedUrl, blob);
      const completeRes = await api.postDraftSocialMediaImageComplete(
        context.getters.postDraftSocialMediaImageCompleteParams(false)
      );
      context.commit(
        "updateUserCroppedSocialMediaImageUrl",
        completeRes.data.imageUrl
      );

      return completeRes;
    } catch (error) {
      log.error("postSocialMediaImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async deleteSocialMediaImage(context) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      await api.deleteDraftSocialMediaImage(
        context.getters.deleteDraftSocialMediaImageParams
      );
      context.commit("updateUserCroppedSocialMediaImageUrl", "");
    } catch (error) {
      log.error("deleteSocialMediaImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async postDefaultSocialMediaImage(context, blob) {
    try {
      const postRes = await api.postDraftSocialMediaImage(
        context.getters.postDraftSocialMediaImageParams(true)
      );
      await commonApi.postS3Image(postRes.data.signedUrl, blob);
      const completeRes = await api.postDraftSocialMediaImageComplete(
        context.getters.postDraftSocialMediaImageCompleteParams(true)
      );
      context.commit(
        "updateDefaultCroppedSocialMediaImageUrl",
        completeRes.data.imageUrl
      );

      return completeRes.data.imageUrl;
    } catch (error) {
      log.error("postDefaultSocialMediaImage error:", error);
      context.commit("common/setError", error, { root: true });
    }
  },
  async postFrontCoverImage(context, file) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      const postRes = await api.postDraftFrontCoverImage(
        context.getters.postDraftCoverImageParams
      );

      if (ua.getBrowser().name === "IE") {
        await commonApi.postS3Image(postRes.data.signedUrl, file.file);
      } else {
        const canvas = await loadImageWithOrientationCorrection(file.file, {
          maxWidth: 2048,
          maxHeight: 2048
        });
        await commonApi.postS3Image(
          postRes.data.signedUrl,
          dataUrlToBlob(canvas.toDataURL())
        );
      }

      const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
      await sleep(7000);

      const completeRes = await api.postDraftFrontCoverImageComplete(
        context.getters.postDraftCoverImageCompleteParams
      );

      context.commit("updateUserFrontCoverImageUrl", completeRes.data.imageUrl);
      context.commit("updateFrontCoverData", file.name);
      context.commit("updateFrontCoverImageWidth", file.width);
      context.commit("updateFrontCoverImageHeight", file.height);

      return completeRes.data.imageUrl;
    } catch (error) {
      log.error("postFrontCoverImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async postBackCoverImage(context, file) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      const postRes = await api.postDraftBackCoverImage(
        context.getters.postDraftCoverImageParams
      );

      if (ua.getBrowser().name === "IE") {
        await commonApi.postS3Image(postRes.data.signedUrl, file.file);
      } else {
        const canvas = await loadImageWithOrientationCorrection(file.file);
        await commonApi.postS3Image(
          postRes.data.signedUrl,
          dataUrlToBlob(canvas.toDataURL())
        );
      }

      const completeRes = await api.postDraftBackCoverImageComplete(
        context.getters.postDraftCoverImageCompleteParams
      );

      const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
      await sleep(15000);

      context.commit("updateUserBackCoverImageUrl", completeRes.data.imageUrl);
      context.commit("updateBackCoverData", file.name);

      return completeRes.data.imageUrl;
    } catch (error) {
      log.error("postBackCoverImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async postDefaultSpineImage(context, blob) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      const postRes = await api.postDraftSpineImage(
        context.getters.postDraftSpineImageParams({
          isDefault: true
        })
      );
      await commonApi.postS3Image(postRes.data.signedUrl, blob);
      const completeRes = await api.postDraftSpineImageComplete(
        context.getters.postDraftSpineImageCompleteParams({
          isDefault: true
        })
      );

      context.commit("updateDefaultSpineImageFile", blob);
      context.commit("updateDefaultSpineImageUrl", completeRes.data.imageUrl);

      return completeRes;
    } catch (error) {
      log.error("postDefaultSpineImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async deleteDefaultSpineImage(context) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      await api.deleteDraftSpineImage(
        context.getters.deleteDraftSpineImageParams({
          isDefault: true
        })
      );

      context.commit("updateDefaultSpineImageUrl", "");
    } catch (error) {
      log.error("postDefaultSpineImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async postUserSpineImage(context, blob) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      const postRes = await api.postDraftSpineImage(
        context.getters.postDraftSpineImageParams({
          isDefault: false
        })
      );
      await commonApi.postS3Image(postRes.data.signedUrl, blob);
      const completeRes = await api.postDraftSpineImageComplete(
        context.getters.postDraftSpineImageCompleteParams({
          isDefault: false
        })
      );

      context.commit("updateUserSpineImageFile", blob);
      context.commit("updateUserSpineImageUrl", completeRes.data.imageUrl);

      return completeRes;
    } catch (error) {
      log.error("postUserSpineImage error:", error);
      context.commit("common/setError", error, { root: true });
    } finally {
      context.commit("common/setIsBusy", false, { root: true });
    }
  },
  async publish(context) {
    try {
      const res = await api.postPublish(context.getters.postPublishParams);

      return res.data.redirectUrl;
    } catch (error) {
      log.error("publish error:", error);
      // リクエストタイムアウトは想定動作とし、エラー処理を行わない
      if (error.status !== 504) {
        context.commit("common/setError", error, { root: true });
        throw error;
      }
    }
  },
  async publishProgress(context) {
    try {
      const res = await api.getPublishProgress(
        context.getters.getPublishProgressParams
      );

      switch (res.data.status) {
        case "complete":
        case "error":
          context.commit("common/setIsBusy", false, { root: true });
          break;
      }

      return { status: res.data.status, redirectUrl: res.data.redirectUrl };
    } catch (error) {
      log.error("publishProgress error:", error);
      context.commit("common/setError", error, { root: true });
      throw error;
    }
  },
  async preview(context) {
    try {
      context.commit("common/setIsBusy", true, { root: true });
      await api.postDraftPreview(context.getters.postDraftPreviewParams);
    } catch (error) {
      log.error("preview error:", error);
      // リクエストタイムアウトは想定動作とし、エラー処理を行わない
      if (error.status !== 504) {
        context.commit("common/setError", error, { root: true });
        throw error;
      }
    }
  },
  async previewProgress(context) {
    try {
      const res = await api.getDraftPreviewProgress(
        context.getters.getDraftPreviewProgressParams
      );

      switch (res.data.status) {
        case "complete":
          context.commit("updatePreview", res.data.viewerUrl);
          context.commit("updateIsUpdatedImage", false);
          context.commit("updateIsUpdatedHybrid3dSettings", false);
          context.commit("common/setIsBusy", false, { root: true });
          break;
        case "error":
          context.commit("common/setIsBusy", false, { root: true });
          break;
      }

      return {
        status: res.data.status,
        viewerUrl: res.data.viewerUrl
      };
    } catch (error) {
      log.error("previewProgress error:", error);
      context.commit("common/setError", error, { root: true });
    }
  },
  async getIceContentsInitialSettings(context) {
    try {
      const res = await api.getIceContentsInitialSettings(
        context.getters.getIceContentsInitialSettingsParams
      );
      context.commit(
        "updatePageProgressionDirection",
        res.data.pageProgressionDirection
      );
      context.commit("updateIceContentsPageCount", res.data.pageCount);

      return res;
    } catch (error) {
      log.error("getIceContentsInitialSettings error:", error);
      context.commit("common/setError", error, { root: true });
    }
  },
  async updateHybrid3dSettings(context) {
    try {
      const res = await api.updateHybrid3dSettings(
        context.getters.updateHybrid3dSettingsParams
      );
      context.commit("updatePreview", res.data.viewerUrl);
      context.commit("updateIsUpdatedHybrid3dSettings", false);
      return {
        status: res.status,
        viewerUrl: res.data.viewerUrl
      };
    } catch (error) {
      log.error("updateHybrid3dSettings error:", error);
      context.commit("common/setError", error, { root: true });
    }
  },
  async setInitialStaticImageData(context) {
    const { isBlank = true, draftId } = context.state;
    const { commit } = context;

    switch (state.pageProgressionDirection) {
      case "ltr":
      case "rtl":
      default:
        // ステップ１で白紙画像を2つ確保する
        try {
          if (state.frontCoverNextData.imageId < 0) {
            const res01 = await api.postDraftImage({ isBlank, draftId });
            commit("updateFrontCoverNextData", {
              staticImageName: "frontCoverNextImage",
              imageId: res01.data.imageId,
              isBlank: true,
              isBody: true,
              notMove: true
            });
          }

          if (state.backCoverPrevData.imageId < 0) {
            const res02 = await api.postDraftImage({ isBlank, draftId });
            commit("updateBackCoverPrevData", {
              staticImageName: "backCoverPrevImage",
              imageId: res02.data.imageId,
              isBlank: true,
              isBody: true,
              notMove: true
            });
          }

          const isOddImageCount =
            state.images.filter(image => !image.notMove).length % 2 === 1;
          if (isOddImageCount && state.staticBlankData.imageId < 0) {
            const res03 = await api.postDraftImage({ isBlank, draftId });
            commit("updateStaticBlankData", {
              staticImageName: "blankArea",
              imageId: res03.data.imageId,
              isBlank: true,
              isBody: true,
              notMove: true
            });
          }
        } catch (error) {
          log.error("setInitialStaticImageData error:", error);
          context.commit("common/setError", error, { root: true });
          throw error;
        }
        break;
      case "single":
      case "vertical":
        break;
    }
  },
  async putBlankStaticCoverBack(context, params) {
    const { isBlank = true, draftId } = context.state;
    const { commit } = context;
    const { preImageId, isFrontNext } = params;

    if (preImageId < 0) {
      return;
    }
    try {
      const res = await api.postDraftImage({ isBlank, draftId });

      const mutationsName = isFrontNext
        ? "updateFrontCoverNextData"
        : "updateBackCoverPrevData";
      const staticImageName = isFrontNext
        ? "frontCoverNextImage"
        : "backCoverPrevImage";
      commit(mutationsName, {
        staticImageName: staticImageName,
        imageId: res.data.imageId,
        isBlank: true,
        isBody: true,
        notMove: true
      });

      const staticCoverBackData = isFrontNext
        ? state.frontCoverNextData
        : state.backCoverPrevData;
      commit("updateImages", {
        imageId: preImageId,
        image: staticCoverBackData
      });

      return true;
    } catch (error) {
      log.error("putBlankArea error:", error);
      context.commit("common/setError", error, { root: true });
      throw error;
    }
  },
  async putBlankArea(context) {
    const { isBlank = true, draftId } = context.state;
    const { commit } = context;

    const preImageId = context.state.staticBlankData.imageId;
    if (preImageId > 0) {
      return;
    }
    try {
      const res = await api.postDraftImage({ isBlank, draftId });

      commit("updateStaticBlankData", {
        staticImageName: "blankArea",
        imageId: res.data.imageId,
        isBlank: true,
        isBody: true,
        notMove: true
      });

      commit("updateImages", {
        imageId: preImageId,
        image: state.staticBlankData
      });

      return true;
    } catch (error) {
      log.error("putBlankArea error:", error);
      context.commit("common/setError", error, { root: true });
      throw error;
    }
  },
  async deleteBlankArea(context) {
    const { commit } = context;
    const imageId = context.state.staticBlankData.imageId;
    log.debug("deleteBlankArea:", imageId);

    if (imageId < 0) {
      return;
    }
    try {
      await api.deleteDraftImage({ imageId });

      commit("updateStaticBlankData", {
        staticImageName: "blankArea",
        imageId: -99995,
        isBlank: true,
        isBody: true,
        notMove: true
      });

      return true;
    } catch (error) {
      log.error("deleteBlankArea error:", error);
      context.commit("common/setError", error, { root: true });
      throw error;
    }
  },
  async deleteStaticImageData(context) {
    const { commit, state } = context;

    try {
      if (state.frontCoverNextData.imageId > 0) {
        await api.deleteDraftImage({
          imageId: state.frontCoverNextData.imageId
        });
        commit("updateFrontCoverNextData", {
          staticImageName: "frontCoverNextImage",
          imageId: -99992,
          isBlank: true,
          isBody: true,
          notMove: true
        });
      }

      if (state.backCoverPrevData.imageId > 0) {
        await api.deleteDraftImage({
          imageId: state.backCoverPrevData.imageId
        });
        commit("updateBackCoverPrevData", {
          staticImageName: "backCoverPrevImage",
          imageId: -99998,
          isBlank: true,
          isBody: true,
          notMove: true
        });
      }

      if (state.staticBlankData.imageId > 0) {
        await api.deleteDraftImage({
          imageId: state.staticBlankData.imageId
        });
        commit("updateStaticBlankData", {
          staticImageName: "blankArea",
          imageId: -99995,
          isBlank: true,
          isBody: true,
          notMove: true
        });
      }
    } catch (error) {
      log.error("deleteStaticImageData error:", error);
      context.commit("common/setError", error, { root: true });
      throw error;
    }
  }
};

// mutations
const mutations = {
  startDeleteDraftImage(state, payload) {
    state.images = [
      ...state.images.map(item => {
        return item.imageId === payload ? { ...item, isDeleting: true } : item;
      })
    ];
  },
  successPostDraft(state, payload) {
    state.draftId = payload.draftId;
  },
  updateDraftId(state, payload) {
    state.draftId = payload;
  },
  updatePageProgressionDirection(state, payload) {
    state.isUpdatedImage = true;
    state.pageProgressionDirection = payload;
  },
  updateSortImages(state, payload) {
    state.images = [...payload];
    state.isUpdatedImage = true;
  },
  setUploadingImageCount(state, payload) {
    state.uploadingImageCount = payload;
  },
  pushImages(state, payload) {
    let images = {};
    let isOddNumber = false;

    switch (state.pageProgressionDirection) {
      case "ltr":
      case "rtl":
      default:
        images = [...state.images.filter(image => !image.notMove)];

        images.unshift(state.frontCoverNextData);
        images.unshift(state.frontCoverData);
        images = [...images, payload];
        isOddNumber = Boolean(images.length % 2);
        if (isOddNumber) {
          images.push(state.staticBlankData);
        }
        images.push(state.backCoverPrevData);
        images.push(state.backCoverData);
        state.images = [...images];
        break;
      case "vertical":
      case "single":
        state.images = [...state.images, payload];
        break;
    }

    state.uploadingImage = [...state.uploadingImage, payload];
    state.isUpdatedImage = true;

    log.debug(`pushImages payload:${payload}`);
  },
  updateImages(state, { imageId, image }) {
    log.debug(imageId, image);

    state.images = [
      ...state.images.map(item => {
        return item.imageId === imageId ? { ...image } : item;
      })
    ];

    state.isUpdatedImage = true;
  },
  removeImages(state, imageId) {
    log.debug(imageId);
    state.images = [...state.images.filter(image => image.imageId !== imageId)];
    state.isUpdatedImage = true;
  },
  pushUploadedImage(state, payload) {
    state.uploadedImage = [...state.uploadedImage, payload];
  },
  setIsImageBusy(state, payload) {
    log.debug("setIsImageBusy:", payload);

    state.isUploadingImage = payload;

    // falseだった場合は、アップロード中の画像データをクリア
    if (!payload) {
      state.uploadingImage = [];
      state.uploadedImage = [];
    }
  },
  updateUserThumbnailCroppedImageUrl(state, payload) {
    state.userThumbnailCroppedImageUrl = payload;
  },
  updateUserCroppedSocialMediaImageUrl(state, payload) {
    state.userCroppedSocialMediaImageUrl = payload;
  },
  updateTitle(state, payload) {
    state.title = payload;
  },
  updateDescription(state, payload) {
    state.description = payload;
  },
  updatePublicationType(state, payload) {
    state.publicationType = payload;
  },
  updateSecretWord(state, payload) {
    state.secretWord = payload;
  },
  updateIsSensitive(state, payload) {
    state.isSensitive = payload;
  },
  updateIsCommentEnabled(state, payload) {
    state.isCommentEnabled = payload;
  },
  updateJwt(state, payload) {
    state.jwt = payload;
  },
  updateIsSecureView(state, payload) {
    state.isSecureView = payload;
  },
  updateIsEnabledCircleMs(state, payload) {
    state.isEnabledCircleMs = payload;
  },
  updateDefaultThumbnailOriginalImageUrl(state, payload) {
    state.defaultThumbnailOriginalImageUrl = payload;
  },
  updateDefaultThumbnailCroppedImageUrl(state, payload) {
    state.defaultThumbnailCroppedImageUrl = payload;
  },
  updateUserThumbnailOriginalImageUrl(state, payload) {
    state.userThumbnailOriginalImageUrl = payload;
  },
  updateDefaultOriginalSocialMediaImageUrl(state, payload) {
    state.defaultOriginalSocialMediaImageUrl = payload;
  },
  updateDefaultCroppedSocialMediaImageUrl(state, payload) {
    state.defaultCroppedSocialMediaImageUrl = payload;
  },
  updateUserOriginalSocialMediaImageUrl(state, payload) {
    state.userOriginalSocialMediaImageUrl = payload;
  },
  updateUserFrontCoverImageUrl(state, payload) {
    state.userFrontCoverImageUrl = payload;
    state.isUpdatedImage = true;
  },
  updateFrontCoverImageWidth(state, payload) {
    state.frontCoverImageWidth = payload;
  },
  updateFrontCoverImageHeight(state, payload) {
    state.frontCoverImageHeight = payload;
  },
  updateFrontCoverData(state, payload) {
    state.frontCoverData.fileName = payload;
  },
  updateFrontCoverType(state, payload) {
    state.frontCoverType = payload;
    state.isUpdatedImage = true;
  },
  updateUserBackCoverImageUrl(state, payload) {
    state.userBackCoverImageUrl = payload;
    state.isUpdatedImage = true;
  },
  updateBackCoverData(state, payload) {
    state.backCoverData.fileName = payload;
  },
  updateBackCoverType(state, payload) {
    state.backCoverType = payload;
    state.isUpdatedImage = true;
  },
  updateAspectRatioType(state, payload) {
    state.aspectRatioType = payload;
    state.isUpdatedHybrid3dSettings = true;
  },
  updateCoverHardness(state, payload) {
    state.coverHardness = payload;
    state.isUpdatedHybrid3dSettings = true;
  },
  updateCoverProcess(state, payload) {
    state.coverProcess = payload;
    state.isUpdatedHybrid3dSettings = true;
  },
  updateBodyPaperType(state, payload) {
    state.bodyPaperType = payload;
    state.isUpdatedHybrid3dSettings = true;
  },
  updateSpineCoverType(state, payload) {
    state.spineCoverType = payload;
    state.isUpdatedHybrid3dSettings = true;
  },
  updateDefaultSpineImageFile(state, payload) {
    state.defaultSpineImageFile = payload;
  },
  updateDefaultSpineImageUrl(state, payload) {
    state.defaultSpineImageUrl = payload;
    state.isUpdatedHybrid3dSettings = true;
  },
  updateUserSpineImageFile(state, payload) {
    state.userSpineImageFile = payload;
  },
  updateUserSpineImageUrl(state, payload) {
    state.userSpineImageUrl = payload;
    state.isUpdatedHybrid3dSettings = true;
  },
  updatePreview(state, payload) {
    state.previewUrl = payload;
  },
  updateIsDefaultHybrid3d(state, payload) {
    state.isDefaultHybrid3d = payload;
    state.isUpdatedHybrid3dSettings = true;
  },
  updateIsUploadIceContents(state, payload) {
    state.isUploadIceContents = payload;
  },
  updateIsUpdatedImage(state, payload) {
    state.isUpdatedImage = payload;
  },
  updateIceContentsPageCount(state, payload) {
    state.iceContentsPageCount = payload;
    if (state.iceContentsPageCount < 2) {
      state.pageProgressionDirection = "single";
    }
  },
  updateIceContentsHasCover(state, payload) {
    state.iceContentsHasCover = payload;
  },
  updateIsUpdatedHybrid3dSettings(state, payload) {
    state.isUpdatedHybrid3dSettings = payload;
  },
  updateIsSetSpine(state, payload) {
    state.isSetSpine = payload;
  },
  updateSizeSelect: function(state, payload) {
    state.sizeSelect = payload;
    switch (state.sizeSelect) {
      case "big":
      default:
        state.size = state.pageProgressionDirection === "single" ? "B1" : "A4";
        state.orientation = "portrait";
        break;
      case "middle":
        state.size = state.pageProgressionDirection === "single" ? "A2" : "B5";
        state.orientation = "portrait";
        break;
      case "small":
        state.size = state.pageProgressionDirection === "single" ? "A4" : "B6";
        state.orientation = "portrait";
        break;
      case "big-landscape":
        state.size = state.pageProgressionDirection === "single" ? "B1" : "A4";
        state.orientation = "landscape";
        break;
      case "middle-landscape":
        state.size = state.pageProgressionDirection === "single" ? "A2" : "B5";
        state.orientation = "landscape";
        break;
      case "small-landscape":
        state.size = state.pageProgressionDirection === "single" ? "A4" : "B6";
        state.orientation = "landscape";
        break;
    }
    state.isUpdatedHybrid3dSettings = true;
  },
  updateSize(state, payload) {
    state.size = payload;
  },
  refreshImages(state) {
    let images = {};
    let isOddNumber = false;

    switch (state.pageProgressionDirection) {
      case "ltr":
      case "rtl":
      default:
        images = [...state.images.filter(image => !image.notMove)];
        if (images.length === 0) {
          break;
        }

        images.unshift(state.frontCoverNextData);
        images.unshift(state.frontCoverData);
        isOddNumber = Boolean(images.length % 2);
        if (isOddNumber) {
          images.push(state.staticBlankData);
        }
        images.push(state.backCoverPrevData);
        images.push(state.backCoverData);
        break;
      case "vertical":
      case "single":
        images = [...state.images.filter(image => !image.notMove)];
        state.images = [...images];
        break;
    }
    state.images = [...images];
  },
  updateStepNumber(state, payload) {
    state.stepNumber = payload;
  },
  updateIsSetFrontCoverNext(state, payload) {
    state.isSetFrontCoverNext = payload;
  },
  updateIsSetBackCoverPrev(state, payload) {
    state.isSetBackCoverPrev = payload;
  },
  updateFrontCoverNextData(state, payload) {
    state.frontCoverNextData = payload;
  },
  updateBackCoverPrevData(state, payload) {
    state.backCoverPrevData = payload;
  },
  updateStaticBlankData(state, payload) {
    state.staticBlankData = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
